module.exports = __webpack_public_path__ + "img/岸本隆一.c9963d33.png";